import { tap, map, shareReplay } from 'rxjs/operators';
import {
  Address,
  AddressDetails,
  CartObject,
  CartResponse,
  Line,
} from './interfaces/cartObject';
import {
  CurrentNav,
  NavigationObject,
  ShoppingProducts,
  ShoppingProductsParameters,
  TableTitles,
  DeleteItemParams,
} from './interfaces/ShoppingProductsItem';
import { HttpClient } from '@angular/common/http';
import { Subject, Observable, pipe, BehaviorSubject } from 'rxjs';
import { EventEmitter, Injectable } from '@angular/core';
import * as g from '../../globals';
import { ShoppingCartConfiguration } from './interfaces/configuration';
import { LayoutService } from 'src/app/layout/layout.service';
import { ShoppingCartStructure } from './interfaces/ShoppingCartStructure';
import {
  Dictionary,
  ShoppingCartQueue,
  SubmittedShoppingCart,
} from './interfaces/shoppingCartQueue';
import { Area } from '@app/models/UserIdentity';
@Injectable()
export class ShoppingCartService {
  UpdateLines = new EventEmitter();
  getCustomerInfo = new EventEmitter();
  fileDropped = new EventEmitter();
  quantityUpdated = new EventEmitter();
  warrentyHandler: EventEmitter<ShoppingProducts> = new EventEmitter();
  snChooserHandler: EventEmitter<ShoppingProducts> = new EventEmitter();
  customVariantHandler: EventEmitter<ShoppingProducts> = new EventEmitter();
  warehouseSelectorHandler: EventEmitter<ShoppingProducts> = new EventEmitter();
  fullShoppingCartExecuted: EventEmitter<CartObject> = new EventEmitter();

  fieldUpdated = new EventEmitter();
  configurations$ = new BehaviorSubject<Dictionary<string, any>[]>([]);
  constructor(private http: HttpClient, private layoutService: LayoutService) {}

  static scrollShoppingItemToTop: boolean = false;

  getShoppingItems(
    params: ShoppingProductsParameters
  ): Observable<ShoppingProducts[]> {
    return this.http.post<ShoppingProducts[]>(
      g.apiBaseUrl + 'ShoppingCart/ShoppingProducts',
      params
    );
  }
  getConfiguration(configName: string) {
    const configs = this.configurations$.value;
    const config = configs.find((c) => c.Key === configName);
    if (config != null) {
      const configObserver = this.configurations$.asObservable();
      return configObserver.pipe(
        map((c) => c.find((c) => c.Key === configName).Value)
      );
    } else {
      return this.layoutService.getConfiguration(configName).pipe(
        tap((c) => {
          const dic: Dictionary<string, any> = { Key: configName, Value: c };
          configs.push(dic);
          this.configurations$.next(configs);
        })
      );
    }
  }
  //temp
  // getConfiguration(configName: string) {
  //   return this.GetShoppingCartConfigs().pipe(
  //     map((x) => x[configName]),
  //     shareReplay(1)
  //   );
  // }
  getItemsTableTitles(ShoppingCartId: number): Observable<TableTitles[]> {
    return this.http.get<TableTitles[]>(
      g.apiBaseUrl +
        'ShoppingCart/productsTableTitles?dbShoppingCartId=' +
        ShoppingCartId
    );
  }

  shoppingNavigation(params: NavigationParams): Observable<NavigationObject> {
    if (params.cardCode === '' || params.cardCode == null) {
      if (g.userIdentity.Area === Area.CustomerPortal) {
        params.cardCode = g.userIdentity.CardCode;
      }
    }

    return this.http.post<NavigationObject>(
      g.apiBaseUrl + 'ShoppingCart/ShoppingNavigation',
      params
    );
  }

  getShoppingCartInfo(
    dbShoppingCartId: string,
    cartNumber: string
  ): Observable<CartResponse> {
    return this.http.get<CartResponse>(
      `${g.apiBaseUrl}ShoppingCart/FullShoppingCartInfo?dbShoppingCartId=${dbShoppingCartId}&cartNumber=${cartNumber}`
    );
  }

  queueToUpdate(
    dbShoppingCartId: any,
    submittedShoppingCart: SubmittedShoppingCart,
    UDF: any
  ) {
    return this.http.post(`${g.apiBaseUrl}ShoppingCart/QueueToUpdate`, {
      dbShoppingCartId,
      submittedShoppingCart,
      UDF,
    });
  }

  exportCartToExcel(docEntry: any) {
  return this.http.post(
    `${g.apiBaseUrl}ShoppingCart/ExportCartToExcel`,
    { docEntry },
    {
      responseType: 'blob',
    },
  );
}

  setItemWarranty(
    dbShoppingCartId: any,
    submittedShoppingCart: SubmittedShoppingCart
  ) {
    return this.http.post(`${g.apiBaseUrl}ShoppingCart/SetItemWarranty`, {
      dbShoppingCartId,
      submittedShoppingCart,
    });
  }

  setSerialOptions(
    dbShoppingCartId: any,
    submittedShoppingCart: SubmittedShoppingCart
  ) {
    return this.http.post(`${g.apiBaseUrl}ShoppingCart/SetSerialOptions`, {
      dbShoppingCartId,
      submittedShoppingCart,
    });
  }

  setCustomVariant(
    dbShoppingCartId: any,
    submittedShoppingCart: SubmittedShoppingCart
  ) {
    return this.http.post(`${g.apiBaseUrl}ShoppingCart/SetCustomVariant`, {
      dbShoppingCartId,
      submittedShoppingCart,
    });
  }

  GetShoppingCartStructure(
    shoppingCartId: string
  ): Observable<ShoppingCartStructure> {
    return this.http.get<ShoppingCartStructure>(
      `${g.apiBaseUrl}ShoppingCart/GetShoppingCartStructure?shoppingCartId=${shoppingCartId}`
    );
  }
  // to be called before choosing a costumer
  ShoppingCartConfiguration() {
    return this.http
      .get<ShoppingCartConfiguration>(
        `${g.apiBaseUrl}ShoppingCart/GetConfiguraiton`
      )
      .pipe(shareReplay(1));
  }

  //#region to be called after choosing a costumer
  // getAddresses(Code, shoppingCartId: string) {
  //   return this.http.get(
  //     `${g.apiBaseUrl}ShoppingCart/GetListOfBillingShipping?dbShoppingCartId=${shoppingCartId}&cardCode=${Code}`
  //   );
  // }

  // getContactPersons(Code: string) {
  //   return this.layoutService.executeQuery(2788, {
  //     cardCode: Code,
  //   });
  // }

  // ContactPersonFromDraft(cardCode: string) {
  //   return this.http.get(
  //     `${g.apiBaseUrl}ShoppingCart/GetContactPersonDraft?cardCode=${cardCode}`
  //   );
  // }

  GetShoppingCartConfigs() {
    return this.http.get(`${g.apiBaseUrl}ShoppingCart/GetShoppingCartConfigs`);
  }

  GetSectionInfo(sectionId: number) {
    return this.http.get(
      `${g.apiBaseUrl}Data/GetSectionInfo?sectionId=${sectionId}`
    );
  }

  GetItemTaxRate(cardCode: string, itemCode: string, shipToCode: string) {
    return this.http.get(
      `${g.apiBaseUrl}Data/GetItemTaxRate?cardCode=${cardCode}&itemCode=${itemCode}&shipToCode=${shipToCode}`
    );
  }

  updateDocumentProperty(formData: FormData) {
    return this.http.post(
      `${g.apiBaseUrl}ShoppingCart/updateDocumentProperty`,
      formData
    );
  }
  DocumentCreationButtons() {
    return this.http.get(
      `${g.apiBaseUrl}ShoppingCart/DocumentsCreationButtons`
    );
  }

  SubmitCart(
    shoppingCartId: string,
    documentType: number,
    dbShoppingCartId: number,
    saveAsDraft: boolean
  ) {
    return this.http.post(`${g.apiBaseUrl}ShoppingCart/SubmitCart`, {
      shoppingCartId,
      documentType,
      dbShoppingCartId: +dbShoppingCartId,
      isDraft: saveAsDraft,
    });
  }

  DeleteItem(deleteItemParams: DeleteItemParams) {
    return this.http.post(
      `${g.apiBaseUrl}ShoppingCart/DeleteItem`,
      deleteItemParams
    );
  }

  clearCart(cardCode: string, docEntry: string) {
    return this.http.post(`${g.apiBaseUrl}ShoppingCart/EraseCart`, {
      cardCode,
      docEntry,
    });
  }

  CreateNewShippingAddress(
    dbShoppingCartId: string,
    cardCode: string,
    addressDetails: AddressDetails
  ) {
    return this.http.post(
      `${g.apiBaseUrl}ShoppingCart/CreateNewShippingAddress`,
      {
        dbShoppingCartId,
        cardCode,
        addressDetails,
      }
    );
  }

  getAddressSection() {
    return this.layoutService.getSection(10232).pipe(
      map((data: any) => {
        return data.Fields;
      })
    );
  }

  async checkProductBeforeAddingToCart(
    dbShoppingCartId: string,
    originalItem: ShoppingProducts,
    quantity: number,
    config: ShoppingCartConfiguration
  ): Promise<{ isValid: boolean; message: string; validQuantity: number }> {
    if (!config.AllowAddOutofStockItems && originalItem.OnHand <= 0) {
      if (
        config.OutOfStockErrorMsg == null ||
        config.OutOfStockErrorMsg === undefined ||
        config.OutOfStockErrorMsg === ''
      ) {
        return {
          isValid: false,
          message:
            'No quantity available for product: ' + originalItem.ItemName,
          validQuantity: 0,
        };
      } else {
        return {
          isValid: false,
          message: config.OutOfStockErrorMsg.replace(
            '[#ItemCode]',
            originalItem.ItemName
          ),
          validQuantity: 0,
        };
      }
    }
    if (
      config.BlockAddingBelowMaximum &&
      originalItem.OnHand > 0 &&
      quantity > originalItem.OnHand
    ) {
      return {
        isValid: true,
        message: 'Only ' + originalItem.OnHand + ' were submited',
        validQuantity: originalItem.OnHand,
      };
    }
    if (
      config.BlockAddingBelowMinimum &&
      originalItem.MinOrdrQty != null &&
      quantity !== 0 &&
      quantity < originalItem.MinOrdrQty
    ) {
      return {
        isValid: false,
        message:
          'Failed to add the product to shopping cart, minimum quantity is ' +
          originalItem.MinOrdrQty,
        validQuantity: 0,
      };
    }

    if (
      config.EnableQuantityMultiRule &&
      originalItem.MultOrdQty != null &&
      quantity % originalItem.MultOrdQty !== 0
    ) {
      return {
        isValid: false,
        message:
          'The product ' +
          originalItem.ItemName +
          ' can be added with multiplication of ' +
          originalItem.MultOrdQty,
        validQuantity: 0,
      };
    }

    await this.getQuantityLimitationForItem(
      originalItem.ItemCode,
      dbShoppingCartId,
      quantity
    )
      .toPromise()
      .then((d: any) => {
        console.log(d);
        if (d.Has_Error) {
          return {
            isValid: false,
            message: d.Error_Message,
            validQuantity: 0,
          };
        }
        var res = JSON.parse(d.Resault_Value);
        if (res != null && res.Has_Error) {
          return {
            isValid: false,
            message: res.Error_Message,
            validQuantity: 0,
          };
        }

        if (config.AllowAddOutofStockItems && originalItem.OnHand <= 0) {
          if (
            config.OutOfStockWarningMsg != null &&
            config.OutOfStockWarningMsg !== undefined &&
            config.OutOfStockWarningMsg !== ''
          ) {
            return {
              isValid: true,
              message: config.OutOfStockWarningMsg.replace(
                '[#ItemCode]',
                originalItem.ItemName
              ),
              validQuantity: quantity,
            };
          }
        }
        return {
          isValid: true,
          message: '',
          validQuantity: quantity,
        };
      });

    if (config.AllowAddOutofStockItems && originalItem.OnHand <= 0) {
      if (
        config.OutOfStockWarningMsg != null &&
        config.OutOfStockWarningMsg !== undefined &&
        config.OutOfStockWarningMsg !== ''
      ) {
        return {
          isValid: true,
          message: config.OutOfStockWarningMsg.replace(
            '[#ItemCode]',
            originalItem.ItemName
          ),
          validQuantity: quantity,
        };
      }
    }
    return {
      isValid: true,
      message: '',
      validQuantity: quantity,
    };
  }

  getQuantityLimitationForItem(
    itemCode: string,
    dbShoppingCartId: string,
    quantity: number
  ) {
    return this.http.get(
      `${g.apiBaseUrl}ShoppingCart/GetQuantityLimitationForItem?itemCode=${itemCode}&dbShoppingCartId=${dbShoppingCartId}&quantity=${quantity}`
    );
  }

  getListOfShoppingCarts(cardCode: string, dbShoppingCartId: string) {
    return this.http.get(
      `${g.apiBaseUrl}ShoppingCart/GetListOfShoppingCarts?cardCode=${cardCode}&dbShoppingCartId=${dbShoppingCartId}`
    );
  }

  GenerateToken(
    moduleId: number,
    objectType: string,
    objectKey: number,
    token: string
  ) {
    return this.http.get(
      `${
        g.baseUrl + 'Tokeniz/'
      }Tokeniz/GenerateToken?token=${token}&language=en&moduleId=${moduleId}&objectType=${objectType}&objectKey=${objectKey}`
    );
  }
}

export interface NavigationParams {
  cardCode: string;
  currentNav: { [key: string]: CurrentNav } | any;
  dbShoppingCartId: string;
  onlyCount: string;
  searchValue: string;
}
